import { GlIcon, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { isNumber } from 'lodash-es';
import { n__ } from '~/locale';
import { isNotDiffable, stats } from '../utils/diff_file';
export default {
    name: 'DiffStats',
    components: {
        GlIcon,
        GlSprintf
    },
    props: {
        diffFile: {
            type: Object,
            required: false,
            default: ()=>null
        },
        addedLines: {
            type: Number,
            required: true
        },
        removedLines: {
            type: Number,
            required: true
        },
        diffsCount: {
            type: [
                String,
                Number
            ],
            required: false,
            default: null
        },
        hideOnNarrowScreen: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        diffFilesLength () {
            return parseInt(this.diffsCount, 10);
        },
        filesText () {
            return n__('%{count} file', '%{count} files', this.diffFilesLength);
        },
        isCompareVersionsHeader () {
            return Boolean(this.diffsCount);
        },
        hasDiffFiles () {
            return isNumber(this.diffFilesLength) && this.diffFilesLength >= 0;
        },
        notDiffable () {
            return isNotDiffable(this.diffFile);
        },
        fileStats () {
            return stats(this.diffFile);
        },
        statsLabel () {
            const counters = [];
            if (this.addedLines > 0) counters.push(n__('RapidDiffs|Added %d line.', 'RapidDiffs|Added %d lines.', this.addedLines));
            if (this.removedLines > 0) counters.push(n__('RapidDiffs|Removed %d line.', 'RapidDiffs|Removed %d lines.', this.removedLines));
            return counters.join(' ');
        }
    }
};
